import React, {useEffect, useMemo, useState} from 'react';
import {message, Modal, Spin, Transfer, Typography} from 'antd';
import userApi from '../api/userApi';

const { Text } = Typography;

/**
 * 사용자 그룹 멤버 편집 모달
 * props:
 *  - open: boolean
 *  - group: { groupId, trgtIdList } | null (USER 타입 그룹)
 *  - onCancel()
 *  - onSubmit(userIds: string[])
 */
const GroupUserMembersModal = ({ open, group, onCancel, onSubmit }) => {
  const [loading, setLoading] = useState(false);
  const [allUsers, setAllUsers] = useState([]); // 전체 사용자 목록
  const [targetKeys, setTargetKeys] = useState([]); // 선택된 멤버 (userId 문자열 배열)

  useEffect(() => {
    if (!open) return;
    const load = async () => {
      setLoading(true);
      try {
        const res = await userApi.listUsers();
        if (res && Array.isArray(res.data)) {
          setAllUsers(res.data);
        } else {
          setAllUsers([]);
          message.warning('사용자 목록 응답 형식이 올바르지 않습니다.');
        }
      } catch (e) {
        message.error('사용자 목록 조회 실패: ' + (e?.message || ''));
      } finally { setLoading(false); }
    };
    load();
  }, [open]);

  // 그룹 변경/열릴 때 기존 멤버 반영
  useEffect(() => {
    if (group && open) {
      setTargetKeys((group.trgtIdList || []).map(id => id));
    } else if (!open) {
      setTargetKeys([]);
    }
  }, [group, open]);

  const dataSource = useMemo(() => {
    return (allUsers || []).map(u => ({
      key: u.userId,
      title: u.userNm || u.lgnUserNm || u.eml,
      description: `${u.lgnUserNm || ''} / ${u.eml || ''}`
    }));
  }, [allUsers]);

  const handleOk = () => {
    onSubmit?.(targetKeys);
  };

  return (
    <Modal
      open={open}
      title={`사용자 멤버 편집${group ? '' : ' (그룹 미선택)'}`}
      onCancel={onCancel}
      onOk={handleOk}
      okButtonProps={{ disabled: !group }}
      okText="저장"
      cancelText="취소"
      destroyOnClose
      width={760}
    >
      {!group && <Text type="secondary">USER 타입 그룹을 먼저 선택하세요.</Text>}
      {group && (
        <div style={{ minHeight: 360 }}>
          {loading ? <div style={{textAlign:'center',padding:40}}><Spin /></div> : (
            <Transfer
              dataSource={dataSource}
              titles={['전체 사용자', '그룹 멤버']}
              targetKeys={targetKeys}
              onChange={setTargetKeys}
              listStyle={{ width: 320, height: 360 }}
              showSearch
              filterOption={(inputValue, item) => (item.title || '').toLowerCase().includes(inputValue.toLowerCase()) || (item.description || '').toLowerCase().includes(inputValue.toLowerCase())}
              locale={{
                itemUnit: '명', itemsUnit: '명', searchPlaceholder: '검색', notFoundContent: '없음'
              }}
              render={item => `${item.title}`}
            />
          )}
        </div>
      )}
    </Modal>
  );
};

export default GroupUserMembersModal;

